// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
// The vouchered part of a bookshop's basket, grouped the way the app groups it.
//
// A shop's basket accumulates books from several customers through the day,
// and at close of day the lot goes to SIB as one trade. Flat, it is a list of
// strangers' books with no way to tell whose is whose. Under the voucher that
// was issued for them, each customer's books read as their own pile - which is
// how the shop thinks about them, and how the app has always shown them.
import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const VoucherGroups = ({ classes, groups }) => {
  if (!groups || groups.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      {groups.map(group => (
        <div className={classes.group} key={group.VoucherId || uuidv4()}>
          <div className={classes.groupHeader}>
            {/* Same line as the app: "{name} - voucher {code}". A customer
                who gave no name still has a voucher, so the code carries the
                heading on its own rather than leaving it blank. */}
            <p className={classes.groupTitle}>
              {group.CustomerName
                ? `${group.CustomerName} — voucher ${group.Code}`
                : `Voucher ${group.Code}`}
            </p>
            <p className={classes.groupValue}>
              {`£${parseFloat(group.IssueValue || 0).toFixed(2)}`}
            </p>
          </div>

          {(group.Books || []).map(book => (
            <div className={classes.bookRow} key={book.OrderDetailsId || uuidv4()}>
              <p className={classes.bookTitle}>{book.Title || 'Title unavailable'}</p>
              <p className={classes.bookPrice}>
                {`£${parseFloat(book.SellbackPrice || 0).toFixed(2)}`}
              </p>
            </div>
          ))}

          <p className={classes.groupFooter}>
            {`${group.BookCount || (group.Books || []).length} book(s) against this voucher`}
          </p>
        </div>
      ))}
    </div>
  );
};

VoucherGroups.propTypes = {
  classes: PropTypes.object,
  /** VoucherGroups from GetBookshopBasket. */
  groups: PropTypes.array,
};

VoucherGroups.defaultProps = {
  classes: {},
  groups: [],
};

export default withStyles(styles)(VoucherGroups);
